/* eslint-disable jsx-a11y/anchor-is-valid */
import { Col, Row } from "antd";
import styles from "./styles/AppContainerFooter.module.css";
import home from "~assets/general/home_inactive.svg";
import settings from "~assets/general/setting_inactive.svg";
import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

const AppContainerFooter = () => {
  const token = jwtDecode(localStorage.getItem("token"));
  const loginAs = token?.loginAs;
  const navigate = useNavigate();

  useEffect(() => {
    if (!loginAs) {
      localStorage.removeItem(token);
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Row justify="center">
      <Col>
        <Link to={`/v2/${loginAs}`}>
          <a className={styles.footerLink}>
            <img
              src={home}
              alt="home"
              style={{ height: "inherit", width: "inherit" }}
            />
          </a>
        </Link>
      </Col>
      <Col>
        <Link to={"/v2/settings"}>
          <a className={styles.footerLink}>
            <img
              src={settings}
              alt="settings"
              style={{ height: "inherit", width: "inherit" }}
            />
          </a>
        </Link>
      </Col>
    </Row>
  );
};

export default AppContainerFooter;
